import { Command } from 'commander';
import { getV2Client } from '../../api/v2-client.js';
import type { IV2Client } from '../../api/v2-client.js';
import { handleV2Error } from '../../handle-error.js';
import { resolveSpaceIdBySlug } from './show.js';
import { resolveUserIdByEmail } from '../_members-resolver.js';

interface InviteOpts { org?: string; }

export async function runSpaceInvite(slug: string, email: string, opts: InviteOpts, client?: IV2Client): Promise<void> {
  const c = client ?? await getV2Client(opts.org ?? undefined);
  const spaceId = await resolveSpaceIdBySlug(c, slug);
  const userId = await resolveUserIdByEmail(c, email);
  const resp = await c.post<{ added: boolean; member: { name: string } }>(`/api/v2/spaces/${spaceId}/members`, { user_id: userId });
  if (resp.added) process.stdout.write(`✓ Added ${resp.member.name} to ${slug}.\n`);
  else process.stdout.write(`${resp.member.name} was already a member of ${slug}.\n`);
}

export const spaceInviteCommand = new Command('invite')
  .description('Add a grid member to a space (admin only)')
  .argument('<slug>', 'Space slug')
  .argument('<email>', 'Email of an existing grid member')
  .option('--org <slug>', 'Override active grid')
  .action(async (slug: string, email: string, opts: InviteOpts) => {
    try { await runSpaceInvite(slug, email, opts); }
    catch (err) { await handleV2Error(err); }
  });
